import { Avatar, Grid, styled, Typography } from '@mui/material';
import { truncateText } from '../../../../common-utilities';
import type { ReactNode } from 'react';

type AssureAppCardHeaderProps = {
  avatarImage?: ReactNode;
  appName?: string;
  background?: string;
};

export const AvatarBox = styled(Avatar)(() => ({
  filter: 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25))',
}));

export const AssureAppCardHeader = ({ ...props }: AssureAppCardHeaderProps) => {
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      sx={{
        background: props.background,
        padding: '0 0 0 16px',

        height: '80px',
        '& .MuiCardHeader-action': {
          marginTop: '16px',
        },
      }}
    >
      <Grid item>
        <AvatarBox variant="rounded" data-testid="app-card-logo">
          {props.avatarImage}
        </AvatarBox>
      </Grid>
      <Grid item xs>
        <Typography
          noWrap={false}
          sx={{
            backgroundColor: 'rgba(255, 254, 254, 0.63)',
            width: '100%',
            boxShadow: '0px 2px 6px 2px rgba(0, 0, 0, 0.25)',
            fontWeight: 700,
            fontSize: '14px',
            padding: '4px 15px', // Remove horizontal padding
          }}
          data-testid="app-card-title"
        >
          {truncateText(props.appName || '', 30)}
        </Typography>
      </Grid>
    </Grid>
  );
};
